/** Coverage status the API resolves for a check-in. Never recalculated on the client. */
export enum CheckInStatus {
  ACTIVE = 'ACTIVE',
  EXPIRING_SOON = 'EXPIRING_SOON',
  EXPIRED = 'EXPIRED',
  CANCELED = 'CANCELED',
  NO_SUBSCRIPTION = 'NO_SUBSCRIPTION',
  /** Frontend only: check-ins registered before the status column existed. */
  UNKNOWN = 'UNKNOWN',
  /** Frontend only: phone number not registered, attempt stored as a failed check-in. */
  MEMBER_NOT_FOUND = 'MEMBER_NOT_FOUND',
  /** Frontend only: fingerprint sample did not match a registered member. */
  FINGERPRINT_NOT_RECOGNIZED = 'FINGERPRINT_NOT_RECOGNIZED',
}
